module.exports = __webpack_public_path__ + "img/img24.55e4a0dc.svg";